<template>
    <div class="col-sm-12">
        <p class="mega-title m-b-5">Buying Option</p>
    </div>
    <div class="col-sm-6">
        <div class="card">
            <div class="d-flex p-20">
                <div class="form-check radio radio-warning me-3">
                    <input class="form-check-input" id="radio26" type="radio" name="radio1" value="option1">
                    <label class="form-check-label" for="radio26"></label>
                </div>
                <div class="flex-grow-1">
                    <h6 class="mt-0 mega-title-badge">XYZ Seller<span class="badge badge-warning pull-right digits">250
                            INR</span></h6>
                    <p class="rating-star-wrapper"><i class="icofont icofont-star txt-warning"></i><i
                            class="icofont icofont-star txt-warning"></i><i class="icofont icofont-star txt-warning"></i><i
                            class="icofont icofont-star txt-warning"></i><i
                            class="icofont icofont-star txt-warning m-r-5"></i>5 start rating</p>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="card mb-0">
            <div class="d-flex p-20">
                <div class="form-check radio radio-danger me-3">
                    <input class="form-check-input" id="radio27" type="radio" name="radio1" value="option1">
                    <label class="form-check-label" for="radio27"></label>
                </div>
                <div class="flex-grow-1">
                    <h6 class="mt-0 mega-title-badge">ABC Seller<span class="badge badge-danger pull-right digits">150
                            INR</span></h6>
                    <p class="rating-star-wrapper"><i class="icofont icofont-star txt-warning"></i><i
                            class="icofont icofont-star"></i><i class="icofont icofont-star"></i><i
                        class="icofont icofont-star"></i><i class="icofont icofont-star m-r-5"></i>1 start rating</p>
            </div>
        </div>
    </div>
</div></template>